import { Box, Stack, useColorModeValue, Text, Heading } from '@chakra-ui/react';
import { courses } from '../data/courses';
import Card from './Card';
import { useNavigate } from 'react-router-dom';

const Course = () => {
	const courseId = +localStorage.getItem('courseId')!!;
	const course = courses[courseId];
	const navigate = useNavigate();

	return (
		<Box w='full' bg={useColorModeValue('#202020', 'gray.900')} p={0}>
			<Stack
				justify='space-between'
				p={[0, 4]}
				w='full'
				direction={['column']}>
				<Heading
					w='full'
					color={'wheat'}
					fontSize='xl'
					textAlign={'center'}>
					{course.title}
				</Heading>
				{course.content.playlists.length > 0 && (
					<Box bg={'#2e2e2e'} m={'1rem'} p={'5px 5px'}>
						<Heading
							w='full'
							color={'#b3b3b3'}
							fontSize='xl'
							bg={'#202020'}
							p={'10px'}>
							Playlists
						</Heading>
						<Box
							p={4}
							display='flex'
							flexWrap={'wrap'}
							justifyContent='center'>
							{course.content.playlists.map((playlist) => {
								return (
									<Box
										p={4}
										flexBasis='400px'
										borderRadius='lg'
										bg={'#202020'}
										cursor='pointer'
										_hover={{
											transform: 'scale(1.02)',
										}}
										margin={'10px'}
										onClick={() => {
											localStorage.setItem(
												'playlist',
												JSON.stringify(playlist)
											);
											navigate('/playlist');
										}}>
										<Stack>
											<Text color={'white'} fontSize='xl'>
												{playlist.title}
											</Text>
											<Text color={'wheat'}>
												<b>{playlist.videos.length}</b>{' '}
												videos
											</Text>
										</Stack>
									</Box>
								);
							})}
						</Box>
					</Box>
				)}
				{course.content.pdfs.length > 0 && (
					<Box bg={'#2e2e2e'} m={'1rem'} p={'5px 5px'}>
						<Heading
							w='full'
							color={'#b3b3b3'}
							fontSize='xl'
							bg={'#202020'}
							p={'10px'}>
							PDFs
						</Heading>
						<Box
							p={4}
							display='flex'
							flexWrap={'wrap'}
							justifyContent='center'>
							{course.content.pdfs.map((pdf) => {
								return (
									<Box
										p={4}
										flexBasis='400px'
										borderRadius='lg'
										bg={'#202020'}
										cursor='pointer'
										_hover={{
											transform: 'scale(1.02)',
										}}
										margin={'10px'}
										onClick={() => {
											window.open(pdf.link);
										}}>
										<Text
											w='full'
											color={'white'}
											fontSize='xl'>
											{pdf.title}
										</Text>
									</Box>
								);
							})}
						</Box>
					</Box>
				)}
				{course.content.articles.length > 0 && (
					<Box bg={'#2e2e2e'} m={'1rem'} p={'5px 5px'}>
						<Heading
							w='full'
							color={'#b3b3b3'}
							fontSize='xl'
							bg={'#202020'}
							p={'10px'}>
							Articles
						</Heading>
						<Box
							p={4}
							display='flex'
							flexWrap={'wrap'}
							justifyContent='center'>
							{course.content.articles.map((article) => {
								return (
									<Box
										p={4}
										flexBasis='400px'
										borderRadius='lg'
										cursor='pointer'
										_hover={{
											transform: 'scale(1.02)',
										}}>
										{/* <Text
											w='full'
											color={'white'}
											fontSize='xl'>
											{article.title}
										</Text> */}
										<Card data={article} />
									</Box>
								);
							})}
						</Box>
					</Box>
				)}
			</Stack>
		</Box>
	);
};

export default Course;
